<template>
    <div class="record-selection-wrap">
        <div class="list-wrap">
            <el-scrollbar
                    class="default-scrollbar content-bg"
                    wrap-class="default-scrollbar__wrap"
                    view-class="p20-scrollbar__view">
                <el-row v-if="listLoading || list && list.length > 0" :gutter="20" v-loading.body="listLoading">
                    <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="4" v-for="item in list" :key="item.id" class="record-item">
                        <el-card shadow="hover" :body-style="{ padding: '15px'}" style="border-radius: 10px;">
                            <record-window :data="item" @click-window="select(item)" @click-leave="handleLeave(item)"></record-window>
                        </el-card>
                    </el-col>
                </el-row>
                <div v-else class="none-list">
                    <span>暂无病历</span>
                </div>
            </el-scrollbar>
        </div>
        <div class="footer">
            <el-pagination background
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="pagination.current"
                           :page-sizes="pagination.sizes"
                           :page-size="pagination.size"
                           :layout="pagination.layout"
                           :total="pagination.total"></el-pagination>
        </div>
    </div>
    <!--<el-container>
        <el-main>
            <el-scrollbar
                    class="default-scrollbar content-bg"
                    wrap-class="default-scrollbar__wrap"
                    view-class="p20-scrollbar__view">
                <el-row v-if="listLoading || list && list.length > 0" :gutter="20" v-loading.body="listLoading">
                    <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="4" v-for="item in list" :key="item.id" class="record-item">
                        <el-card shadow="hover" :body-style="{ padding: '15px'}" style="border-radius: 10px;">
                            <record-window :data="item" @click-window="select(item)" @click-leave="handleLeave(item)"></record-window>
                        </el-card>
                    </el-col>
                </el-row>
                <div v-else class="none-list">
                    <span>暂无病历</span>
                </div>
            </el-scrollbar>
        </el-main>
        <el-footer class="footer" height="35px">
            <el-pagination background
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="pagination.current"
                           :page-sizes="pagination.sizes"
                           :page-size="pagination.size"
                           :layout="pagination.layout"
                           :total="pagination.total"></el-pagination>
        </el-footer>
    </el-container>-->
</template>

<script>
    import _ from 'lodash'
    import RecordService from '@/request/record/record'
    export default {
        name: "RecordPatientRecordSelection",
        props: {
            patient: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                listLoading: false,
                list: [],
                pagination: {
                    sort: 'admissionDate',
                    order: 'desc',
                    size: 10,
                    total: 0,
                    current: 1,
                    layout: 'total, sizes, prev, pager, next, jumper',
                    sizes: [10, 20, 30]
                }
            }
        },
        computed: {},
        created: function () {
            this.listRecord()
        },
        watch: {
            patient (newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.listRecord();
                }
            }
        },
        methods: {
            listRecord () {
                if (!this.patient) {
                    this.list = []
                    return
                }
                this.listLoading = true
                RecordService.find(this.pagination, {
                    patient: this.patient
                }).then(res => {
                    const data = res.result
                    this.list = _.concat([], data.content)
                    this.pagination.total = data.totalElements || 0
                }).catch(() => {
                    this.list = []
                }).finally(() => {
                    this.listLoading = false
                })
            },
            handleSizeChange: function (val) {
                var self = this
                self.pagination.size = val
                self.pagination.current = 1
                self.listRecord()
            },
            handleCurrentChange: function (val) {
                var self = this
                self.pagination.current = val
                self.listRecord()
            },
            select (item) {
                this.$emit('selected', item.id)
            },
            handleLeave (item) {
                if (!item) {
                    return
                }
                this.$confirm('患者：' + item.patName + '、床号：' + item.bedid + '，确认将此病历修改为出院状态？', '提示', {type: 'warning'}).then(() => {
                    item.state = 7
                    RecordService.save(item).then(res => {
                        if (!_.isEmpty(res.result)) {
                            this.listRecord()
                        }
                    })
                }, () => {
                    this.$message({
                        message: '取消操作!',
                        type: 'success'
                    })
                })
            }
        },
        filters: {}
    }
</script>

<style scoped>
    .record-selection-wrap {
        height: 100%;
    }
    .list-wrap {
        min-height: 640px;
        margin-bottom: 10px;
    }
</style>
